import { CalendarModule } from 'primeng/calendar';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BetweenDatesComponent } from './components/between-dates/between-dates.component';
import { BetweenNumbersComponent } from './components/between-numbers/between-numbers.component';
import { DateComponent } from './components/date/date.component';

@NgModule({
  declarations: [
    BetweenDatesComponent,
    BetweenNumbersComponent,
    DateComponent
  ],
  exports: [
    BetweenDatesComponent,
    BetweenNumbersComponent,
    DateComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule
    ],
})
export class MojoControlsModule { }
